import { Plugin } from '@ckeditor/ckeditor5-core';
import Calculatorediting from './calculatorediting';
import Calculatorui from './calculatorui';

export default class Calculator extends Plugin {
	static get requires() {
		return [ Calculatorediting, Calculatorui ];
	}
}
